<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
           
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            
            
            <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in caseStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="item">
                <div class="label">是否已结算:</div>
                <el-select v-model="conditionData.IsEndCount" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in iSsettlementList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" icon="el-icon-download" size="small" @click="getExcel">导出excel</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                prop="carOutsourceNo"
                label="案件ID"
                align="center"
                width="100"
                >
                </el-table-column>
                
                <el-table-column
                prop="month"
                label="所属派驻月份"
                align="center"
                width="180"
                >
                </el-table-column>
                <el-table-column
                prop="personnel"
                label="派驻人员"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="expatriate"
                label="所属分公司"
                align="center"
                width="120"
                >
                </el-table-column>
                
                <el-table-column
                prop="sonCompany"
                label="地区"
                align="center"
                width="120"
                >
                </el-table-column>
               <el-table-column
                prop="underwriteInstitution"
                label="派驻承保公司"
                align="center"
                width="200"
                
                >
                </el-table-column>
                <el-table-column
                prop="assessCost"
                label="标准公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="实际公估费"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="120"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==6">未完成未开票</span>
                    <span v-if="scope.row.financeState==9">已完成未开票</span>
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="importTime"
                label="导入时间"
                align="center"
                width="180"
                >
                </el-table-column>
                
                <el-table-column
                prop="iSsettlement"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.iSsettlement==0">未结算</span>
                    <span v-if="scope.row.iSsettlement==1">已结算</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="standName"
                label="立项名称"
                align="center"
                width="150"
                >
                </el-table-column>
                
                <el-table-column
                prop="remarks"
                label="未决备注"
                align="center"
                width="300"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceDetail(scope.row)">查看关联立项</el-button>
                    <el-button type="text" icon="el-icon-date" size="mini" @click="dailyList(scope.row)">查看日志</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCaseTip(scope.row)" v-if="isHandle=='1'">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="案件详情" width="860px">
            <div class="dialog">
                <div class="item">
                    <div class="label">车险编号:</div>
                    <el-input v-model="detailData.carOutsourceNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">承保公司:</div>
                    <el-input v-model="detailData.underwriteInstitution" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">外派机构:</div>
                    <el-input v-model="detailData.expatriate" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">所属派驻月份:</div>
                    <el-input v-model="detailData.month" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">人员:</div>
                    <el-input v-model="detailData.personnel" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">公估费:</div>
                    <el-input v-model="detailData.assessCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">实际公估费:</div>
                    <el-input v-model="detailData.actualCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>

               
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="detailData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in financeStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">导入时间:</div>
                    <el-input v-model="detailData.importTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">是否结算:</div>
                    <el-select v-model="detailData.iSsettlement" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in iSsettlementList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="item item-textarea">
                    <div class="label">未决备注:</div>
                    <el-input type="textarea" v-model="detailData.remarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
                <div class="item">
                    <div class="label">创建时间:</div>
                    <el-input v-model="detailData.createTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDetail" title="查看关联立项" width="1600px">
            <el-table
                :data="invoiceList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                prop="standProjectId"
                width="120"
                label="立项ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==6">未完成未开票</span>
                    <span v-if="scope.row.financeState==9">已完成未开票</span>
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <!-- <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceItemDetail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column> -->
            </el-table>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentInvoiceChange"
                    background
                    layout="prev, pager, next ,sizes ,total"
                    :total="invoiceCount"
                    :current-page="conditionInvoiceData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionInvoiceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDailyDialog" title="查看日志" width="800px">
            <el-timeline>
                <el-timeline-item :timestamp="item.cDateTime" placement="top" v-for="(item,index) in daily" :key="index">
                <p> 
                    {{item.behavior==0?'插入':''}}
                    {{item.behavior==1?'更新':''}}
                    {{item.behavior==2?'单个关联':''}}
                    {{item.behavior==3?'批量关联':''}}
                    {{item.behavior==4?'取消关联':''}}
                </p>
                </el-timeline-item>
               
            </el-timeline>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import { provinceAndCityData , CodeToText } from "element-china-area-data";
import {carOutstandTermStatus,carTypeList,companyTypeList,businessModuleList,moduleList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            time:'',
            district:'',
            provinceAndCityData:provinceAndCityData,
            title:'',
            isDetailDialog:false,
            totalCount:0,
            conditionData:{
                Multiple:"",
                financeState:"",
                IsEndCount:null,
                StartTime:"",
                EndTime:null,
                pageIndex:1,
                pageSize:20,
            },
            tableData:[],
            detailData:{},
            lossStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'已指派未查勘',
                    value:1,
                },{
                    label:'已查勘待审核',
                    value:2,
                },{
                    label:'查勘已审核',
                    value:3,
                },{
                    label:'查勘退回',
                    value:5,
                },{
                    label:'品管已审核待转录',
                    value:6,
                },{
                    label:'已转录待保险公司审核',
                    value:7,
                },
            ],
            caseStatusList:carOutstandTermStatus,
            casePropertyList:[
                {
                    label:'本地案件',
                    value:1,
                },
                {
                    label:'异地案件',
                    value:0,
                }
            ],
            isGuangDong:[
                {
                    label:'是',
                    value:1,
                },
                {
                    label:'否',
                    value:0,
                }
            ],
            iSsettlementList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            isYueList:[
                {
                    label:'否',
                    value:0,
                },{
                    label:'是',
                    value:1,
                },
            ],
            financeStateList:carOutstandTermStatus,


            isRelevanceDetail:false,

            conditionInvoiceData:{
                RelationID:null,
                IsJoinCase:null,
                Multiple:"",
                financeState:null,
                StartTime:"",
                EndTime:"",
                CompanyName:"",
                pageIndex:1,
                pageSize:10,
            },
            invoiceList:[],
            invoiceCount:0,
            row:null,
            isDailyDialog:false,
            daily:[
                
            ],
            isHandle:localStorage.getItem('isHandle')
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async dailyList(row){
            this.isDailyDialog = true;
            let res = await api.externalQueryCaseLogs({
                "caseID": JSON.stringify(row.carOutsourceNo),
                "caseType": 2
            });
            this.daily = res.data.data;

        },
        handleCurrentInvoiceChange(pageIndex){
            this.conditionInvoiceData.pageIndex = pageIndex;
            this.relevanceDetail(this.row);
        },
        async relevanceDetail(row){
            console.log(row);
            this.row = row;
            this.isRelevanceDetail = true;
            this.conditionInvoiceData.RelationID = row.relatedID;
            let res  = await api.carOutsourceGetStandList(this.conditionInvoiceData);
            this.invoiceList = res.data.data.entitys;
            this.invoiceCount = res.data.data.pageLen;
            for(let i in this.invoiceList){
                this.invoiceList[i].billingTimeStr = parseTimeD(this.invoiceList[i].billingTime)
            }
        },
        relevanceItemDetail(row){
            localStorage.setItem('editData',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "carOutsourceDetail",
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            });
            window.open(href, '_blank');
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.StartTime = parseTimeD(this.time[0]);
                this.conditionData.EndTime = parseTimeD(this.time[1]);
            }
            if(this.district){
                this.conditionData.Mechanism = CodeToText[this.district[0]]+','+CodeToText[this.district[1]]
            }
            let res  = await api.carOutsourceGetPagedList(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].commissionTime = parseTimeS(this.tableData[i].commissionTime)
                this.tableData[i].statusTime = parseTimeS(this.tableData[i].statusTime)
            }
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = null;
            this.district = '',
            this.conditionData = {
                Multiple:"",
                financeState:"",
                IsEndCount:null,
                StartTime:"",
                EndTime:null,
                pageIndex:1,
                pageSize:20,
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        
        detail(row){
            this.detailData = row;
            this.isDetailDialog = true;
        },
        async getExcel(){
            let option = {
                Multiple:this.conditionData.Multiple,
                StartTime:this.conditionData.StartTime,
                EndTime:this.conditionData.EndTime,
                IsEndCount:this.conditionData.IsEndCount,
                financeState:this.conditionData.financeState,
            }
            let res = await api.carOutsourceExport(option);
        },


        deleteCaseTip(row){
            this.$confirm('是否删除案件编号：'+row.carOutsourceNo+'?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCase(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteCase(row){
            let res = await api.deleteCarOutsource({
                ID:row.carOutsourceNo
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            width: 360px;
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
        }
        .item-textarea{
            width: 760px;
        }
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
